module.exports = __webpack_public_path__ + "assets/ziyuan_5.94d3c62d.svg";